import { ApplicationConfig, importProvidersFrom, LOCALE_ID, ErrorHandler } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import * as Sentry from '@sentry/angular';

// Modules
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

// Routes & Interceptors
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { systemAdminInterceptor } from './core/interceptors/system-admin.interceptor';

// Sentry Error Handler
import { SentryErrorHandler } from './core/errors/sentry-error-handler';

// Environment
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // Router with Sentry Tracing
    provideRouter(
      routes,
      withPreloading(PreloadAllModules)
    ),

    // Animations
    provideAnimations(),

    { provide: MAT_DATE_LOCALE, useValue: 'ar' },

    // HTTP Client مع Interceptors
    provideHttpClient(
      withFetch(),
      // HTTP Client with Interceptors
      // Order matters: auth -> system-admin -> error -> loading
      withInterceptors([
        authInterceptor,
        systemAdminInterceptor,
        errorInterceptor,
        loadingInterceptor
      ])
    ),

    // Sentry Error Handler
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler,
    },

    // Sentry Trace Service (for routing instrumentation)
    {
      provide: Sentry.TraceService,
      deps: [/* Router will be injected automatically */],
    },

    // Service Worker
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),

    // Material Form Field defaults
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },

    // Third-party modules
    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: environment.defaultLanguage
      }),
      ToastrModule.forRoot({
        timeOut: environment.ui.toastrTimeout,
        positionClass: 'toast-top-left',
        enableHtml: true,
        progressBar: true,
        closeButton: true,
        rtl: environment.ui.rtl
      })
    ])
  ]
};
